import { FieldTitle } from './RedStarTitle';
import Select from 'react-select';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FieldDesc } from './common';
import { TextField } from '@client/new/components/basic';
import { BulletsInput } from './BulletsInput';
import { SelectImageSideInput } from './SelectImageSide';
import {
  ProgramCards,
  ProgramOptionLabel,
  toProgramOption,
} from './ProgramsCarousel';
import { TwoColumns } from './layouts';

type Props = {
  index: number;
  programs: Array<{
    id: number;
    name?: string;
    accessType: string;
    mediaCover?: {
      image?: string;
      cdn01?: string;
    };
  }>;
  influencerId: number;
};
export function ProgramsHighlight({ index, programs, influencerId }: Props) {
  const { register, control, watch } = useFormContext();
  const r = (s) => register(`sections.${index}.${s}`);
  const state = watch(`sections.${index}`);

  const options = programs.map(toProgramOption);

  const selectedPrograms = state.programIds?.length
    ? programs.filter((p) => (state.programIds || []).includes(p.id))
    : [];

  // Render:

  const firstCol = (
    <>
      <div>
        <FieldTitle title={'Headline text'} />
        <TextField
          {...r(`title`)}
          className="mb-[5px] max-w-[680px] w-full"
          inputProps={{
            placeholder: 'Headline text',
            maxLength: 60,
          }}
        />
      </div>

      <div>
        <BulletsInput name={`sections.${index}.bullets`} />
      </div>
    </>
  );
  const secondCol = (
    <>
      <div>
        <FieldTitle title={'Choose program'} />
        <FieldDesc>Select single program to highlight</FieldDesc>
        <Controller
          name={`sections.${index}.programIds`}
          control={control}
          render={({ field: { value, onChange, ref } }) => (
            <Select
              ref={ref}
              options={options}
              formatOptionLabel={ProgramOptionLabel}
              value={options.filter((o) => (value || []).includes(o.value))}
              onChange={(option) => onChange(option ? [option.value] : [])}
              styles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: '56px',
                }),
              }}
            />
          )}
        />
      </div>

      {selectedPrograms.length > 0 && (
        <div>
          <ProgramCards
            programs={selectedPrograms}
            influencerId={influencerId}
          />
          <div className="mt-4">
            <SelectImageSideInput index={index} />
          </div>
        </div>
      )}
    </>
  );
  return <TwoColumns first={firstCol} second={secondCol} />;
}
